<script setup lang="ts">
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'

import {VForm} from "vuetify/components/VForm";

import forgotpwd from '@images/forgotpwd.png'

const errors = ref<Record<string, string | undefined>>({
  userNo: undefined
})

const route = useRoute('forgot-password')
const router = useRouter()


definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})
const form = ref({
  userNo: ''
})

const successMessage = ref('')
const errorMessage = ref('')

const forgotPassword = async () => {
  try {
    const res = await $api('/du/user/password/forgotPassword', {
      method: 'POST',
      body: {
        userNo: form.value.userNo
      },
      onResponse(context) {
        if (context.response.status == 200) {
          successMessage.value = '已將重設密碼連結寄至您的電子信箱，請至'+ context.response._data.email + '確認，如未收到信請至垃圾信件確認'
          errorMessage.value = '' // 清空錯誤訊息
        }
      },
      onResponseError({ response }) {
        successMessage.value = '' // 清空成功訊息
        errors.value = response._data?.errors || {}
        errorMessage.value = response._data?.message || '發生錯誤，請稍後再試'
      },
    })
  }
  catch (err: any) {
    // ofetch 在錯誤狀態碼時會拋出異常，但錯誤已在 onResponseError 中處理
    // 只記錄未預期的錯誤（如網路錯誤），不記錄 HTTP 錯誤狀態碼
    const status = err?.status || err?.response?.status || err?.statusCode
    if (!status) {
      // 沒有狀態碼表示是網路錯誤或其他未預期錯誤
      console.error('未預期的錯誤:', err)
      errorMessage.value = '網路連線錯誤，請稍後再試'
    }
    // 有狀態碼的錯誤已在 onResponseError 中處理，不需要額外處理
  }
}

const refVForm = ref<VForm>()
const onSubmit = () => {
  refVForm.value?.validate()
    .then(({ valid: isValid }) => {
      if (isValid)
        forgotPassword()
    })
}
</script>

<template>
  <VContainer class="d-flex justify-center align-center" fluid style="min-height: 100vh;">
    <VRow class="d-flex justify-center">
      <VCol cols="12" md="6" lg="4">
        <VCard class="pa-5">
          <VCardTitle class="text-center">
            <div class="bg-white rounded pa-2 d-inline-block mx-auto">
              <img :src="forgotpwd" width="196px" class="d-block" alt="Forgot password" />
            </div>
          </VCardTitle>
          <VAlert
            variant="outlined"
            color="success"
            v-if="successMessage != ''"
          >
            {{ successMessage }}
          </VAlert>
          <VAlert
            variant="outlined"
            color="error"
            v-if="errorMessage != ''"
          >
            {{ errorMessage }}
          </VAlert>
          <VForm ref="refVForm"
                 @submit.prevent="onSubmit">

            <!-- 帳號 -->
            <VRow>
              <VCol cols="12">
                <AppTextField
                  v-model="form.userNo"
                  label="帳號"
                  placeholder="請輸入您的帳號"
                  outlined
                  dense
                  required
                  :rules="[requiredValidator]"
                />
              </VCol>
            </VRow>


            <!-- 送出按鈕 -->
            <VRow>
              <VCol cols="12">
                <VBtn :disabled="form.userNo == ''" block color="primary" type="submit">
                  送出
                </VBtn>
              </VCol>
            </VRow>
            <VRow>
              <VCol cols="12" class="text-center">
                <a href="/login" class="text-decoration-none">返回登入頁面</a>
              </VCol>
            </VRow>
          </VForm>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
